import React, { memo, FunctionComponent, useState, useEffect } from "react";
import { Logo } from "./GenericIcon.Styles";
import * as helpers from "./GenericIcon.Helpers";

interface IGenericIconProps {
  sourceText: string;
}

export const GenericIcon: FunctionComponent<IGenericIconProps> = memo(
    (props) => {
        const [fallbackLogo, setFallbackLogo] = useState<string>(null);

        const createFallbackLogo = () => {
            helpers.createGenericIcon(props.sourceText).then((createdLogo) => {
                setFallbackLogo(createdLogo);
            });
        };

        useEffect(createFallbackLogo, []);

        return fallbackLogo ? <Logo src={fallbackLogo} /> : null;
    }
);
